import { getAppStore } from '../../app/AppStore';
import { reloadSpace } from '../../app/sagas/spaces/content/RefreshContentSagas';
import { ServiceLocator } from '../../app/ServiceLocator';
import { ActionHelpers } from '../../commonInfra/contentActions/ActionHelpers';
import { IActionButton } from '../../commonInfra/contentActions/ActionPanelInterfaces';
import { CommonErrorCode } from '../../ts/helpers/ErrorCodes';
import { IDataConnectionInfo } from '../../ts/models/IDataConnectionInfo';
import { Set } from '../../ts/models/Set';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ConnectionEditabilityHelper, EditConnectionAction } from '../../ts/services/EditConnectionAction';

function anySelected<T>(items: Set<T>): boolean {
  return items.size() > 0;
}

export function editDataConnectionAction(): IActionButton<IDataConnectionInfo, {}> {
  return {
    name: 'edit-connection',
    translate: 'editConnection_action',
    isAvailable: anySelected,
    isDisabled: (dataConnections: Set<IDataConnectionInfo>) =>
      dataConnections.size() === 1 &&
        !ConnectionEditabilityHelper.userCanEditConnection(dataConnections.first(), getAppStore().getState()),
    execute: (dataConnections: Set<IDataConnectionInfo>) => {
      const context = ServiceLocator.getAngularActionContext();
      ServiceLocator.get<EditConnectionAction>('EditConnectionAction').confirmEditConnections(dataConnections.toArray(), context)
        .then((result: IResult) => {
          ActionHelpers.deselectNotFound(dataConnections, result, CommonErrorCode.DataConnectionNotFound);
          reloadSpace();
        });
    }
  };
}